// @flow
import { getBooking } from './basicCreators';
import { APIError } from '../generalCreators';

export function updateCurrentBooking(
  bookingId: number,
  organisationId: number
): any {
  return function(dispatch) {
    if (bookingId) {
      // Get the booking details
      return dispatch(getBooking(bookingId, organisationId)).then(
        response =>
          dispatch({ type: 'UPDATE_CURRENT_BOOKING', booking: response }),
        error => dispatch(APIError(error, 'Error updating current Booking'))
      );
    } else {
      const result = dispatch({ type: 'CLEAR_CURRENT_BOOKING' });
      return Promise.resolve(result);
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/bookings/currentBookingCreators.js